export default (val, clean = false) => {
  const num = val ? val.replace(/\D/g, "") : "";
  if (num.length !== 8 || clean) {
    return num;
  }
  return num.replace(/^(\d{5})(\d{3})?/, "$1-$2");
};
